import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

interface SiteBanner {
  id: number;
  message: string;
  link: string;
  link_text: string;
  background_color: 'green' | 'cream' | 'orange';
}

const DISMISSED_KEY = 'site_banner_dismissed_id';

const SiteBannerBar: React.FC = () => {
  const [banner, setBanner] = useState<SiteBanner | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const isSideDrawerOpen = useSelector((state: AppState) => state.nav.isSideDrawerOpen);

  useEffect(() => {
    axios.get<SiteBanner | null>('/api/site-banner/')
      .then(res => {
        if (!res.data) return;
        const dismissedId = sessionStorage.getItem(DISMISSED_KEY);
        if (dismissedId === String(res.data.id)) {
          setDismissed(true);
        } else {
          setBanner(res.data);
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    if (banner) sessionStorage.setItem(DISMISSED_KEY, String(banner.id));
    setDismissed(true);
  };

  if (!banner || dismissed) return null;

  return (
    <div className={`site-banner site-banner--${banner.background_color}${isSideDrawerOpen ? ' site-banner--drawer-open' : ''}`} role="banner">
      <p className="site-banner__message">{banner.message}</p>
      {banner.link && banner.link_text && (
        <a
          href={banner.link}
          className="site-banner__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {banner.link_text}
        </a>
      )}
      <button className="site-banner__close" onClick={dismiss} aria-label="Dismiss banner">
        ✕
      </button>
    </div>
  );
};

export default SiteBannerBar;
